import {TrustAccountActivityType} from '@sollapay/enums';

import {
  BeneficiaryRow,
  BuyerAddedRow,
  BuyerDepositRow,
  BuyerOverpaymentRow,
  BuyerRemovedRow,
  DocumentRow,
  TrustPayoutRow
} from './rows';

import type {TrustAccountActivityDTO} from '@sollapay/types';

interface ActivityFeedRowProps {
  activity: TrustAccountActivityDTO;
}

export function ActivityFeedRow({activity}: ActivityFeedRowProps) {
  switch (activity.activityType) {
    case TrustAccountActivityType.BUYER_DEPOSIT:
    case TrustAccountActivityType.PAYMENT_INSTRUCTION_SENT:
      return <BuyerDepositRow activity={activity} />;
    case TrustAccountActivityType.BUYER_OVERPAYMENT:
      return <BuyerOverpaymentRow activity={activity} />;
    case TrustAccountActivityType.TRUST_PAYOUT:
    case TrustAccountActivityType.PAYOUT_INSTRUCTION_SENT:
      return <TrustPayoutRow activity={activity} />;
    case TrustAccountActivityType.BUYER_ADDED:
      return <BuyerAddedRow activity={activity} />;
    case TrustAccountActivityType.BUYER_REMOVED:
      return <BuyerRemovedRow activity={activity} />;
    case TrustAccountActivityType.BENEFICIARY_ADDED:
    case TrustAccountActivityType.BENEFICIARY_REMOVED:
      return <BeneficiaryRow activity={activity} />;
    case TrustAccountActivityType.DOCUMENT_ADDED:
    case TrustAccountActivityType.DOCUMENT_UPDATED:
    case TrustAccountActivityType.DOCUMENT_REMOVED:
      return <DocumentRow activity={activity} />;
    default: {
      const exhaustiveCheck: never = activity.activityType;
      void exhaustiveCheck;
      return null;
    }
  }
}
